export default __webpack_public_path__ + "static/11_LookBackInAnger-11a2a544d9f86231235af5be54d54f1a.pdf";